import "../Table.scss";

import { FunctionComponent } from "react";
import { ICustomToolbar } from "../ITable";
import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton } from "@mui/x-data-grid";
import { Box, Tooltip } from "@mui/material";

const CustomToolbar: FunctionComponent<ICustomToolbar> = (props) => {
  const { children, sx, className, showManageColumns, showManageFilters } = props;
  return (
    <GridToolbarContainer className={`toolbar ${className}`} sx={{ ...sx, display: 'flex', alignItems: 'center', gap: 2 } as any}>
      {children}
      <Box className="manage-btns-box" sx={{ display: 'flex', gap: 1, order: 2 }}>
        {showManageColumns && (
          <Tooltip title="Manage Columns">
            <GridToolbarColumnsButton className="manage-btn" />
          </Tooltip>
        )}
        {showManageFilters && (
          <Tooltip title="Manage Filters">
            <GridToolbarFilterButton className="manage-btn" />
          </Tooltip>
        )}
      </Box>
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
